import { type ReactElement } from 'react'
import { Banner } from '../../components/banner/banner'
import { About } from '../../components/about/about'
import { Contact } from '../../components/contact/contact'
import { Clinic } from '../../components/clinic/clinic'
import { Cashback } from '../../components/cashback/cashback'
import { Discount } from '../../components/discount/discount'
import { Numbers } from '../../components/numbers/numbers'
import { Testimonials } from '../../components/testimonials/testimonials'
import { Faq } from '../../components/faq/faq'
import { Footer } from '../../components/footer/footer'
import Header from '../../components/header/header'
import { ValidationComposite } from '../../../validation/validators/validation-composite'
import { ValidationBuilder } from '../../../validation/builder/validation-builder'
import { House } from '../../components/house/house'
import { Car } from '../../components/car/car'
import { TvShow } from '../../components/tv-show/tv-show'
import { WhatsAppLinkButton } from '../../components/button/whats-app-link-button/whats-app-link-button'
import { DreamLetter } from '../../components/dream-letter/dream-letter'

const validation = new ValidationComposite([
  ...ValidationBuilder.field('accept').required().build(),
  ...ValidationBuilder.field('email').required().email().build(),
  ...ValidationBuilder.field('name').required().minLength(5).build(),
  ...ValidationBuilder.field('phone').required().phone().build()
])

export function Home (): ReactElement {
  return <>
    <Header />
    <main>
      <Banner />
      <About />
      <Contact validation={validation} />
      <House />
      <Car />
      <TvShow />
      <DreamLetter />
      <Clinic />
      <Cashback />
      <Discount />
      <Numbers />
      <Testimonials />
      <Faq />
    </main>
    <WhatsAppLinkButton />
    <Footer full />
  </>
}
